import { HttpStatus, type HttpStatusCode, type UpperSnakeCase } from '../../lib/entry.js';
import { type ErrorCode, PoolbettingError } from './PoolbettingError.js';

/**
 * Error instance representing when a user isn't authenticated.
 * HTTP 401
 */
export class AuthenticatedError<TCode extends string = ErrorCode> extends PoolbettingError<TCode | 'UNAUTHENTICATED'> {
  protected override httpStatus: HttpStatusCode = HttpStatus.Unauthorized;

  constructor(
    message = 'Authenticated error',
    options?: ErrorOptions,
    code: (TCode & UpperSnakeCase<TCode>) | 'UNAUTHENTICATED' = 'UNAUTHENTICATED'
  ) {
    super(message, options, code);
    this.name = 'AuthenticatedError';
  }
}
